import { useScript } from '@/libs/hooks/src/lib/useScript';
import { createUSAePayMessageListener } from '@chiroup/core/functions/usaePayUtils';
import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

const PAY_JS_URL = import.meta.env.VITE_PAY_JS_URL as string;

export default function PayJsManager() {
  const location = useLocation();

  const shouldLoadPayJs = useMemo(() => {
    const path = location.pathname || '';

    return (
      path.startsWith('/billing') ||
      path.startsWith('/patients') ||
      path.startsWith('/settings/subscription') ||
      path.includes('transaction')
    );
  }, [location.pathname]);

  const scriptStatus = useScript(shouldLoadPayJs ? PAY_JS_URL : null, {
    removeOnUnmount: false,
  });

  useEffect(() => {
    if (scriptStatus === 'ready') {
      (window as any).usaepay.PaymentCard.prototype.addEventListener = function (
        eventType: any,
        response: any
      ) {
        const messageListener = createUSAePayMessageListener(eventType, response);

        window.addEventListener('message', messageListener);

        return function cleanup() {
          window.removeEventListener('message', messageListener);
        };
      };
    } else if (scriptStatus === 'error') {
    }
  }, [scriptStatus]);

  return null;
}
